export default "__VITE_ASSET__DAx3Fjfy__"